import { useAppDispatch } from '../store';
import { setConfirmationMessage } from '../store/slices/application-data';

export interface IConfirmContext {
  show: boolean;
  text: string;
}

let resolveCallback;
function useConfirm() {
  const dispatch = useAppDispatch();
  const fuelConfirm = async (text): Promise<boolean> => {
    await dispatch(setConfirmationMessage(text));

    return new Promise((res, rej) => {
      resolveCallback = res;
    });
  };

  const onConfirm = async () => {
    await dispatch(setConfirmationMessage(null));
    resolveCallback(true);
  };

  const onCancel = async () => {
    await dispatch(setConfirmationMessage(null));
    resolveCallback(false);
  };

  return { fuelConfirm, onConfirm, onCancel };
}

export default useConfirm;
